import React from "react";
import Icons from "../../../Icons/Icons";
import { isSet } from "../../../../Utils/CommonFunctions";

const TableHead = (props)=>{
    const {tableHead,sortHandler,rowsSelectedCount,tableData,changeHandler} = props;
    let tableHeader = [];
    tableHead.map((header,index)=>{
        let styles = isSet(header.styles,{});
        if(header.type==='RadioButton' || header.type==='Checkbox'){
            styles={
                ...styles,
                width:'20px'
            }
        }

        //Sorting Handler
        let thEventHandler ={}
        if(header.clickHandler!==undefined && header.clickHandler!==''&& (tableData && tableData.data)?tableData.data.length!==0:''){
            thEventHandler ={
                onClick:header.clickHandler
            }
        }else {
            thEventHandler ={
                onClick:sortHandler.bind(this,header)
            }
        }
        if(header.isShow && header.isShow===true){
            tableHeader.push(
            <th className="thWidth" style={styles} key={index} {...thEventHandler}  {...header.attributes}> 
                <span className=""> 
                    {header.name}
                    {(header.type==='GridActionWithCheckBox' || header.type ==='Checkbox')?
                        <input 
                            onChange={(header.changeHandler) ?header.changeHandler.bind(this,rowsSelectedCount):changeHandler.bind(this,rowsSelectedCount)}
                            className="form-radio-input m-2" 
                            type="checkbox"
                            name="checkbbox" 
                            checked={(rowsSelectedCount===0)?true:false} /> 
                    :<></>}
                </span> 
                {(header.isSort && header.isSort===true)?
                    <span className="position-absolute icon-right mt-1 mr-2"> 
                        <Icons iconType="TableSort" />
                    </span> 
                :<></>}
                
            </th>);
        }
        return header;
    });
    return(
        <thead className={props.tHeadClassName}>
            <tr key={'tableHeader'}>{tableHeader}</tr>
        </thead> 
    )
}
TableHead.defaultProps={
    tHeadClassName:'table_tHeadBg'
}

export default TableHead;
